var AttachedFilesModule = /** @class */ (function () {
    function AttachedFilesModule() {
    }
    return AttachedFilesModule;
}());
export { AttachedFilesModule };
